import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { BRAND } from '../../theme/brandTokens';

export const dashboardToggleSx = {
  textTransform: 'none',
  fontWeight: 600,
  px: 1.25,
  py: 0.4,
  borderColor: BRAND.line,
  color: BRAND.textMuted,
  '&.Mui-selected': {
    bgcolor: BRAND.accent,
    color: BRAND.onAccent,
    '&:hover': { bgcolor: BRAND.accentDark },
  },
};

const DashboardWindowToggle = ({ options, value, onChange, getLabel, ariaLabel }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    aria-label={ariaLabel}
    onChange={(_, next) => {
      if (next !== null) onChange(next);
    }}
  >
    {options.map((option) => (
      <ToggleButton key={option} value={option} sx={dashboardToggleSx}>
        {getLabel(option)}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default DashboardWindowToggle;
